import React from 'react';
import {Row, Col, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoTrib = ({infoTributaria = {}, actual, lastFormDate}) => {
    const { t } = useTranslation();
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={5}>
                    {t("messages.aml.taxpayerType")}
                    <Input readOnly value={infoTributaria.tipoContribuyente} className={actual && infoTributaria.tipoContribuyente !== actual.tipoContribuyente && "difference"}/>
                </Col>
                <Col span={5}>
                    {t("messages.aml.regimeType")}
                    <Input readOnly value={infoTributaria.regimen} className={actual && infoTributaria.regimen !== actual.regimen && "difference"}/>
                </Col>
                <Col span={5}>
                    {t("messages.aml.resolutionNumber")}
                    <Input readOnly value={infoTributaria.nroResolucion} className={actual && infoTributaria.nroResolucion !== actual.nroResolucion && "difference"}/>
                </Col>
                <Col span={5}>
                    {t("messages.aml.fiscalObligationOtherCountry")}
                    <Input readOnly value={infoTributaria.fiscalObligations} className={actual && infoTributaria.fiscalObligations !== actual.fiscalObligations && "difference"}/>
                </Col>
                <Col span={4}>
                    {t("messages.aml.country")}
                    <Input readOnly value={infoTributaria.fisObligationsCountry ? infoTributaria.fisObligationsCountry : t("messages.aml.nA")} className={actual && infoTributaria.fisObligationsCountry !== actual.fisObligationsCountry && "difference"}/>
                </Col>
            </Row>
        </div>
    );
};

export default InfoTrib;